import React, { useEffect, useState } from "react";
import { errorMsg, successMsg } from "../../Toastify";
import { useSelector } from "react-redux";
import {
  CreateHolidayBulkUpload,
  CreateHolidayMaster,
  GetHolidayList,
  UpdateHolidayMaster,
} from "../../../Repository/Api";
import CustomModal from "../../CustomModal";
import moment from "moment";
const itemsPerPage = 10;

const Holidaymaster = () => {
          const { first_name, desingation, access_token } = useSelector((state) => state?.auth?.auth);
  const token = access_token

  const [holiday, setHoliday] = useState([]);
  const [masterModel, setMasterModel] = useState(false);
  const [createHoliday, setCreateHoliday] = useState({});
  const [validation, setValidation] = useState({});
  const [bulkModal, setBulkModal] = useState(false);
  const [bulkUpload, setBulkUpload] = useState({});
  const [dummyleaveList, setdummyLeaveList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [searchText, setSearchText] = useState("");
  

  const SearchfilteredData = dummyleaveList?.filter((item) =>
    Object.values(item).some((value) =>
      value?.toString().toLowerCase().includes(searchText.toLowerCase())
    )
  );
  useEffect(() => {
    if (searchText) {
      setHoliday(SearchfilteredData);
      setCurrentPage(1)
    } else {
      setHoliday(dummyleaveList);
    }
  }, [searchText, dummyleaveList]);
  useEffect(() => {
    getHolidayList();
  },[]);

  const getHolidayList = async () => {
    const response = await GetHolidayList(token);
    if (response && response.statusCode === 200) {
      // setHoliday(response?.data?.holidays);
      setdummyLeaveList(
        response?.data?.holidays
      );
    } else {
      errorMsg(response.message);
    }
  };
  const setData = (e, key) => {
    let TempData = createHoliday;
    TempData[key] = e;
    setCreateHoliday(TempData);
    if (validation[key]) setValidation({ ...validation, [key]: false });
  };
  const onChangeUpload = (e) => {
    setBulkUpload(e.target.files[0]);
  };
  const CheckValidation = () => {
    let Status = true,
      validdateData = {};
    if (!createHoliday.name) {
      validdateData.name = "Holiday Name is Required";
      Status = false;
    }
    if (!createHoliday.holiday_type) {
      validdateData.holiday_type = "Holiday Type is Required";
      Status = false;
    }
    if (!createHoliday.date) {
      validdateData.date = "Date is Required";
      Status = false;
    }
    setValidation({ ...validation, ...validdateData });
    return Status;
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        name: createHoliday.name,
        holiday_type: createHoliday.holiday_type,
        date: createHoliday.date,
      };
      const response = await CreateHolidayMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateHoliday({});
        setMasterModel(false);
        e.target.reset();
        getHolidayList();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const handleUpdate = async (e) => {
    e.preventDefault();
    if (CheckValidation()) {
      const Payload = {
        id: createHoliday.id,
        name: createHoliday.name,
        date: createHoliday.date,
      };
      const response = await UpdateHolidayMaster(Payload, token);
      if (response && response.statusCode === 200) {
        successMsg(response.message);
        setCreateHoliday({});
        setMasterModel(false);
        e.target.reset();
        getHolidayList();
      } else {
        errorMsg(response.message);
      }
    }
  };
  const UploadDocument = async (e, key) => {
    let formData = new FormData();

    formData.append("file", bulkUpload);
    formData.append(
      "fileName",
      moment().format("YYYYMMDDHHmmss") + "_" + bulkUpload
    );
    formData.append("file_path", "/reference_document");

    const response = await CreateHolidayBulkUpload(formData, token);
    if (response && response.statusCode === 200) {
      successMsg(response.message);
      setBulkModal(false);
      getHolidayList();
    } else {
      errorMsg(response.message);
    }
  };


  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = holiday.slice(indexOfFirstItem, indexOfLastItem);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  return (
    <>
      <div>
        <div className="row justify-content-center mt-3">
          <div className="col-lg-4">
            <div class="input-group flex-nowrap">
              <span class="input-group-text" id="addon-wrapping"><span class="material-symbols-outlined search-input-icon">search</span></span>
              <input type="text" class="form-control search-table-data"
                placeholder="Search"
                aria-describedby="addon-wrapping"
                name="search"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
              />
            </div>
          </div>
          <button
            type="button"
            className="btn add-btn rightbuttonspace col-lg-2"
            onClick={() => setBulkModal(true)}
          >
            <span className="material-symbols-outlined align-middle iconsize">
              add_circle
            </span>
            <span className="align-middle"> Bulk Upload</span>
          </button>
          <button
            type="button"
            className="btn add-btn col-lg-2"
            onClick={() => setMasterModel(true)}
          >
            <span className="material-symbols-outlined align-middle iconsize">
              add_circle
            </span>
            <span className="align-middle"> Add</span>
          </button>

        </div>

        <div className="graphbox">
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col">Designation Name</th>
                <th scope="col">Holiday Type</th>
                <th scope="col">Date</th>
              </tr>
            </thead>
            <tbody>
              {currentItems.length > 0 ? (
                currentItems &&
                currentItems.map((holi, index) => (
                  <tr key={index}>
                    <td>{index + 1}</td>
                    <td
                      className="namelink"
                      onClick={() => {
                        setMasterModel(true);
                        setCreateHoliday(holi);
                      }}
                    >
                      {holi?.name}
                    </td>
                    <td className="textformat">
                      {holi?.holiday_type.replace(/_/g, " ")}
                    </td>
                    <td className="textformat">
                      {moment(holi?.date).format("DD MMM YYYY")}
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td></td>
                  <td>
                    <div> No Data Found </div>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              )}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan="4">
                  {/* <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${
                          currentPage === 1 ? "disabled" : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(holiday.length / itemsPerPage),
                      }).map((_, index) => (
                        <li
                          key={index}
                          className={`page-item ${
                            currentPage === index + 1 ? "active" : ""
                          }`}
                        >
                          <button
                            className="page-link"
                            onClick={() => paginate(index + 1)}
                          >
                            {index + 1}
                          </button>
                        </li>
                      ))}
                      <li
                        className={`page-item ${
                          currentPage ===
                          Math.ceil(holiday.length / itemsPerPage)
                            ? "disabled"
                            : ""
                        }`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav> */}
                  <nav aria-label="...">
                    <ul className="pagination">
                      <li
                        className={`page-item ${currentPage === 1 ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage - 1)}
                        >
                          Previous
                        </button>
                      </li>
                      {Array.from({
                        length: Math.ceil(holiday.length / itemsPerPage),
                      }).map((_, index) => {
                        if (
                          index + 1 >= currentPage - 4 && // Display 4 pages before current page
                          index + 1 <= currentPage + 5 // Display 5 pages after current page
                        ) {
                          return (
                            <li
                              key={index}
                              className={`page-item ${currentPage === index + 1 ? "active" : ""}`}
                            >
                              <button
                                className="page-link"
                                onClick={() => paginate(index + 1)}
                              >
                                {index + 1}
                              </button>
                            </li>
                          );
                        }
                        return null; // Hide pages outside the range
                      })}
                      <li
                        className={`page-item ${currentPage === Math.ceil(holiday.length / itemsPerPage) ? "disabled" : ""}`}
                      >
                        <button
                          className="page-link"
                          onClick={() => paginate(currentPage + 1)}
                        >
                          Next
                        </button>
                      </li>
                    </ul>
                  </nav>
                </td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>

      {/* Master Model */}
      <CustomModal
        open={masterModel}
        onClickOutside={() => {
          setMasterModel(false);
          setCreateHoliday({});
        }}
      >
        <form
          onSubmit={(e) => {
            if (createHoliday.id) {
              handleUpdate(e);
            } else {
              handleSubmit(e);
            }
          }}
        >
          <div className="modal-content Modal-View  m-auto">
            <div className="modalHeader text-center py-2">
              <h5 className="font-bold mt-2">
                {createHoliday.id ? "Update" : "Add New"}
                &nbsp;Designation Master
              </h5>
            </div>
            <div className="modal-body p-0 ">
              <div className="container">
                <div className="row d-flex align-items-center justify-content-center  mt-0">
                  <div className="container ">
                    <div className="row justify-content-center">
                      <div className="col-lg-8">
                        <div className=" my-5 px-3">
                          <div className="row justify-content-center mt-2">
                            <div className="col-lg-10">
                              <div className="mb-3">
                                <label className="labeltext">
                                  Name of the Holiday:
                                </label>
                                <input
                                  type="text"
                                  className="fieldinput"
                                  placeholder="Enter Name of the Holiday"
                                  defaultValue={createHoliday?.name}
                                  onChange={(e) => {
                                    setData(e.target.value, "name");
                                  }}
                                />
                                {validation.name && (
                                  <p className="validationerror">
                                    {validation.name}
                                  </p>
                                )}
                              </div>
                              <div className="mb-3">
                                <label className="labeltext">
                                  Holiday Type:
                                </label>
                                <select
                                  className="fieldinput"
                                  defaultValue={createHoliday?.holiday_type}
                                  onChange={(e) => {
                                    setData(e.target.value, "holiday_type");
                                  }}
                                >
                                  <option value="">Select Officer Type</option>
                                  <option value="closed_holiday">
                                    Closed Holiday
                                  </option>
                                  <option value="restricted_holiday">
                                    Restricted Holiday
                                  </option>
                                </select>
                                {validation.holiday_type && (
                                  <p className="validationerror">
                                    {validation.holiday_type}
                                  </p>
                                )}
                              </div>
                              {createHoliday.id ? (
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Date of the Holiday:
                                  </label>
                                  <input
                                    type="date"
                                    className="fieldinput"
                                    placeholder=""
                                    defaultValue={moment(
                                      createHoliday.date
                                    ).format("yyyy-MM-DD")}
                                    onChange={(e) => {
                                      setData(e.target.value, "date");
                                    }}
                                  />
                                  {validation.date && (
                                    <p className="validationmsg">
                                      {validation.date}
                                    </p>
                                  )}
                                </div>
                              ) : (
                                <div className="mb-3">
                                  <label className="labeltext">
                                    Date of the Holiday:
                                  </label>
                                  <input
                                    type="date"
                                    className="fieldinput"
                                    placeholder=""
                                    value={createHoliday?.date}
                                    onChange={(e) => {
                                      setData(e.target.value, "date");
                                    }}
                                  />
                                  {validation.date && (
                                    <p className="validationmsg">
                                      {validation.date}
                                    </p>
                                  )}
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setMasterModel(false);
                    setValidation({});
                    setCreateHoliday({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button className="btn mx-2 submit-btn">
                  {createHoliday.id ? "Update" : "Create"}
                </button>
              </div>
            </div>
          </div>
        </form>
      </CustomModal>

      {/* Bulk upload Modal */}
      <CustomModal
        open={bulkModal}
        onClickOutside={() => {
          setBulkModal(false);
        }}
      >
        <div className="modal-content Modal-View m-auto">
          <div className="modalHeader text-center py-2">
            <h5 className="font-bold mt-2">Bulk Upload</h5>
          </div>
          <div className="modal-body p-0">
            <div className="container">
              <div className="row d-flex align-items-center justify-content-center  mt-0">
                <div className="container ">
                  <div className="row justify-content-center">
                    <div className="col-lg-12">
                      <div className=" my-5 px-3">
                        <div className="row justify-content-center mt-2">
                          <div className="col-lg-6">
                            <div className="mb-3">
                              <label className="form-label">
                                Upload Report:
                              </label>
                              <input
                                type="file"
                                className="form-control"
                                id="myfile"
                                accept=".xls,.xlsx"
                                name="file"
                                onChange={onChangeUpload}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="modal-footer border-0">
              <div>
                <button
                  type="button"
                  className="btn mx-2 submit-btn"
                  onClick={() => {
                    setBulkModal(false);
                    setBulkUpload({});
                  }}
                >
                  Back
                </button>
              </div>
              <div>
                <button
                  className="btn mx-2 submit-btn"
                  onClick={UploadDocument}
                >
                  Upload
                </button>
              </div>
            </div>
          </div>
        </div>
      </CustomModal>
    </>
  );
};

export default Holidaymaster;
